module.exports = __webpack_public_path__ + "img/ex2.1c6fc761.png";